<template>
  <v-container class="photo-preview-input">
    <v-row class="photo-preview-input-row">
      <v-col class="photo-preview-input-col">
        <div v-if="!uploadedFile"
             :class="['photo-preview-input-div', 'text-center', divClass]"
             @click="readonly ? null: startUpload()">
          <v-row>
            <v-col>
              <font-awesome-icon icon="camera-retro"></font-awesome-icon>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="font-weight-bold">
              {{ label || $t('upload') }}
            </v-col>
          </v-row>
        </div>

        <div v-if="uploadedFile" class="photo-preview-input-preview-div">
          <v-img thumbnail :src="getURL(uploadedFile)" contain height="200px"></v-img>
          <div class="photo-preview-remove-btn" @click="readonly ? null: (uploadedFile = null)">
            <font-awesome-icon icon="times"></font-awesome-icon>
          </div>
        </div>
        <input ref="fileInput" type="file"
               accept="image/jpeg, image/png, image/jpg"
               capture="environment"
               @change="fileUploaded"
               class="invisible">
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {ref, watch} from "@vue/composition-api";
import CameraCaptureModal from "@/components/CameraCaptureModal";

export default {
  name: 'PhotoPreviewInput',
  props: {
    readonly: Boolean,
    divClass: String,
    fileName: String,
    label: String,
    value: [String, Object, File],
    useCamera: Boolean,
  },
  setup(props, {root, emit}) {
    const startUpload = async function () {
      if (props.useCamera) {
        uploadedFile.value = await root.$dialog.showAndWait(CameraCaptureModal);
      } else {
        fileInput.value.click();
      }
    }


    const uploadedFile = ref(null);
    const fileInput = ref(null);
    const fileUploaded = function (e) {
      if (e.target.files[0]) {
        let file = e.target.files[0];
        let blob = file.slice(0, file.size, {type: file.type});

        let components = file.name.split('.');
        let extension = components[components.length - 1];

        try {
          uploadedFile.value = new File([blob], `${props.fileName || 'upload'}.${extension}`, {type: file.type});
        } catch (err) {
          let f = new Blob([blob], {type: file.type});
          f.lastModifiedDate = new Date();
          f.name = `${props.fileName || 'upload'}.${extension}`;
          uploadedFile.value = f;
        }

        fileInput.value.value = null
      }
    };
    const getURL = function (f) {
      if (f instanceof File) {
        return URL.createObjectURL(f);
      } else {
        return 'api/static/' + f;
      }

      // return URL.createObjectURL(f);
    };

    watch(() => uploadedFile.value, (newValue) => {
      emit('input', newValue);
    })

    watch(() => props.value, (newValue) => {
      uploadedFile.value = newValue;
    }, {immediate: true})

    return {
      startUpload,
      uploadedFile,
      fileInput,
      fileUploaded,
      getURL,
    }
  },
}
</script>

<style lang="less">
.photo-preview-input {
  .photo-preview-input-row {
    .photo-preview-input-col {
      height: 200px;

      .photo-preview-input-div {
        padding: 60px;

        .fa-camera-retro {
          font-size: 3rem;
        }
      }


      .photo-preview-input-preview-div {
        &::before {
          content: "";
          opacity: 0.15;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          position: absolute;
        }
      }

      .photo-preview-remove-btn {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        opacity: 0;
        cursor: pointer;
        transition: opacity 0.3s;

        &:hover {
          opacity: 1;
          transition: opacity 0.3s;
        }

        .fa-times {
          color: white;
          height: 50%;
          width: 50%;
          position: absolute;
          left: 25%;
          top: 25%;
        }
      }
    }
  }
}
</style>
